export interface IReactionRequest {
  contentId: number
  contentType: ContentType
  reactionType?: IReactionType
  quantity?: number
}

export type ContentTypeV1 = "photo" | "video" | "message" | "comment"

export interface IReactionRequestV1 {
  contentID: number
  contentType: ContentTypeV1
  type?: IReactionType
  quantity?: number
}

export interface IReactionResponseV1 {
  counts: Record<IReactionType, number>
  userReactions: IReactionType[]
}

export type IReactionType = "love" | "like" | "celebrate" | "wow" | "haha"

export enum ContentType {
  Photo = 0,
  Video = 1,
  Message = 2,
  Comment = 3,
}

export enum SocialsBehavior {
  Disabled = 0,
  None = 1,
  ReactionsOnly = 2,
  CommentsOnly = 3,
  ReactionsAndComments = 4,
}
